import { RuleResult } from 'types/DeclarationP5'
import { excludeDeleted } from 'shared/lib/common-util'
import { removePrefix } from 'shared/ncts/common/classifier-util'
import { DepartureTransportMeans } from '../../common/types'

const C0826Validator = {
  validateDepartureTransportMeansForConsignmentRequirement: ({
    inlandModeOfTransport,
  }: {
    inlandModeOfTransport?: string
  }): RuleResult => {
    if (removePrefix(inlandModeOfTransport, 'TRANSPORT_MODE_', 1) === '5') {
      return 'NOT_ALLOWED'
    }
    return 'OPTIONAL'
  },
  validateDepartureTransportMeansForHouseConsignmentRequirement: ({
    inlandModeOfTransport,
    departureTransportMeans,
  }: {
    inlandModeOfTransport: string
    departureTransportMeans: DepartureTransportMeans[]
  }): RuleResult => {
    if (removePrefix(inlandModeOfTransport, 'TRANSPORT_MODE_', 1) === '5') {
      return 'NOT_ALLOWED'
    }
    if (departureTransportMeans.filter(excludeDeleted).length > 0) {
      return 'NOT_ALLOWED'
    }

    return 'OPTIONAL'
  },

} as const

export default C0826Validator
